// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=none"
// @generated from file poller/v1/pollers.proto (package workernet.pollers, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Any } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_any } from "@bufbuild/protobuf/wkt";
import { file_common_v1_common } from "../../common/v1/common_pb";
import type { OnuSerial } from "../../common/v1/workers_pb";
import { file_common_v1_workers } from "../../common/v1/workers_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file poller/v1/pollers.proto.
 */
export const file_poller_v1_pollers: GenFile = /*@__PURE__*/
  fileDesc("Chdwb2xsZXIvdjEvcG9sbGVycy5wcm90bxIRd29ya2VybmV0LnBvbGxlcnMiTgoNRXF1aXBtZW50SW5mbxIOCgZ2ZW5kb3IYASABKAkSDQoFbW9kZWwYAiABKAkSDgoGc3dfdmVyGAMgASgJEg4KBmh3X3ZlchgEIAEoCSJxCgVPbnVJZBIZCgxvbHRfaWZfaW5kZXgYASABKANIAIgBARIPCgJuchgCIAEoA0gBiAEBEhYKCXVuaXF1ZV9pZBgDIAEoCUgCiAEBQg8KDV9vbHRfaWZfaW5kZXhCBQoDX25yQgwKCl91bmlxdWVfaWQixgEKB1BheWxvYWQSDQoFY291bnQYASABKAMSEAoIaW50ZXJ2YWwYAiABKAESDAoEc2l6ZRgDIAEoAxIMCgRvaWRzGAQgAygJEg8KB3RpbWVvdXQYBSABKAMSDwoHcmV0cmllcxgGIAEoAxIXCg9tYXhfcmVwZXRpdGlvbnMYByABKAMSGAoQY29tbXVuaXR5X3N1ZmZpeBgIIAEoCRISCgpjaHVua19zaXplGAkgASgDEhUKDW9uZV9hdF9hX3RpbWUYCiABKAgijQEKDk9udURlcmVnUmVhc29uEiQKAmlkGAEgASgLMhgud29ya2VybmV0LnBvbGxlcnMuT251SWQSIwoFdmFsdWUYAiABKAsyFC5nb29nbGUucHJvdG9idWYuQW55EjAKBHR5cGUYAyABKA4yIi53b3JrZXJuZXQucG9sbGVycy5EZXJlZ1JlYXNvblR5cGUihAIKB09udUluZm8SJAoCaWQYASABKAsyGC53b3JrZXJuZXQucG9sbGVycy5PbnVJZBIMCgRuYW1lGAIgASgJEigKBHR5cGUYAyABKA4yGi53b3JrZXJuZXQucG9sbGVycy5Qb25UeXBlEi0KAnNuGAQgASgLMhwud29ya2VybmV0LndvcmtlcnMuT251U2VyaWFsSACIAQESCwoDbWFjGAUgASgJEjgKDmVxdWlwbWVudF9pbmZvGAYgASgLMiAud29ya2VybmV0LnBvbGxlcnMuRXF1aXBtZW50SW5mbxIQCghzb3J0X2tleRgHIAEoAxIMCgRkZXNjGAggASgJQgUKA19zbiJbCg5PbnVNZWFzdXJlbWVudBIkCgJpZBgBIAEoCzIYLndvcmtlcm5ldC5wb2xsZXJzLk9udUlkEiMKBXZhbHVlGAIgASgLMhQuZ29vZ2xlLnByb3RvYnVmLkFueSI1CgxPbnVJZlRyYWZmaWMSEQoJaW5fb2N0ZXRzGAEgASgDEhIKCm91dF9vY3RldHMYAiABKAMiWwoLT251SWZFcnJvcnMSFgoJaW5fZXJyb3JzGAEgASgDSACIAQESFwoKb3V0X2Vycm9ycxgCIAEoA0gBiAEBQgwKCl9pbl9lcnJvcnNCDQoLX291dF9lcnJvcnMi9wIKDE9udUludGVyZmFjZRIoCgZvbnVfaWQYASABKAsyGC53b3JrZXJuZXQucG9sbGVycy5PbnVJZBIOCgZudW1iZXIYAiABKAMSFQoIaWZfaW5kZXgYAyABKANIAIgBARIZCgxzdGF0dXNfYWRtaW4YBCABKAhIAYgBARIYCgtzdGF0dXNfb3BlchgFIAEoCEgCiAEBEhwKD3BvcnRfc3BlZWRfbWJpdBgGIAEoA0gDiAEBEjUKB3RyYWZmaWMYByABKAsyHy53b3JrZXJuZXQucG9sbGVycy5PbnVJZlRyYWZmaWNIBIgBARIzCgZlcnJvcnMYCCABKAsyHi53b3JrZXJuZXQucG9sbGVycy5PbnVJZkVycm9yc0gFiAEBQgsKCV9pZl9pbmRleEIPCg1fc3RhdHVzX2FkbWluQg4KDF9zdGF0dXNfb3BlckISChBfcG9ydF9zcGVlZF9tYml0QgoKCF90cmFmZmljQgkKB19lcnJvcnMipwQKCVBvblJlc3VsdBIoCgRvbnVzGAEgAygLMhoud29ya2VybmV0LnBvbGxlcnMuT251SW5mbxI3CgxvbnVfdHhfcG93ZXIYAiADKAsyIS53b3JrZXJuZXQucG9sbGVycy5PbnVNZWFzdXJlbWVudBI3CgxvbnVfcnhfcG93ZXIYAyADKAsyIS53b3JrZXJuZXQucG9sbGVycy5PbnVNZWFzdXJlbWVudBI3CgxvbHRfdHhfcG93ZXIYBCADKAsyIS53b3JrZXJuZXQucG9sbGVycy5PbnVNZWFzdXJlbWVudBI3CgxvbHRfcnhfcG93ZXIYBSADKAsyIS53b3JrZXJuZXQucG9sbGVycy5PbnVNZWFzdXJlbWVudBIzCghkaXN0YW5jZRgGIAMoCzIhLndvcmtlcm5ldC5wb2xsZXJzLk9udU1lYXN1cmVtZW50EjYKC3RlbXBlcmF0dXJlGAcgAygLMiEud29ya2VybmV0LnBvbGxlcnMuT251TWVhc3VyZW1lbnQSOAoNZGVyZWdfcmVhc29ucxgIIAMoCzIhLndvcmtlcm5ldC5wb2xsZXJzLk9udURlcmVnUmVhc29uEjAKBXN0YXRlGAkgAygLMiEud29ya2VybmV0LnBvbGxlcnMuT251TWVhc3VyZW1lbnQSMwoKaW50ZXJmYWNlcxgKIAMoCzIfLndvcmtlcm5ldC5wb2xsZXJzLk9udUludGVyZmFjZSJyCgZTaWduYWwSGAoLc3RyZW5ndGhfcngYASABKANIAIgBARITCgZzbnJfcngYAiABKANIAYgBARITCgZjY3FfdHgYAyABKANIAogBAUIOCgxfc3RyZW5ndGhfcnhCCQoHX3Nucl9yeEIJCgdfY2NxX3R4IjkKB1RyYWZmaWMSDwoCdHgYASABKANIAIgBARIPCgJyeBgCIAEoA0gBiAEBQgUKA190eEIFCgNfcngiNgoEUmF0ZRIPCgJ0eBgBIAEoAUgAiAEBEg8KAnJ4GAIgASgBSAGIAQFCBQoDX3R4QgUKA19yeCLOAgoEUGVlchIQCgNtYWMYASABKAlIAIgBARIPCgJpcBgCIAEoCUgBiAEBEhEKBG5hbWUYAyABKAlIAogBARIZCgx1cHRpbWVfdGlja3MYBCABKAlIA4gBARITCgZ1cHRpbWUYBSABKANIBIgBARIqCgRyYXRlGAYgASgLMhcud29ya2VybmV0LnBvbGxlcnMuUmF0ZUgFiAEBEi4KBnNpZ25hbBgHIAEoCzIZLndvcmtlcm5ldC5wb2xsZXJzLlNpZ25hbEgGiAEBEjAKB3RyYWZmaWMYCCABKAsyGi53b3JrZXJuZXQucG9sbGVycy5UcmFmZmljSAeIAQFCBgoEX21hY0IFCgNfaXBCBwoFX25hbWVCDwoNX3VwdGltZV90aWNrc0IJCgdfdXB0aW1lQgcKBV9yYXRlQgkKB19zaWduYWxCCgoIX3RyYWZmaWMirAEKB0ZkYkl0ZW0SCwoDbWFjGAEgASgJEhAKCGlmX2luZGV4GAIgASgDEgwKBHZpZHMYAyADKAMSDAoEdHlwZRgEIAEoCRITCgZvbnVfbnIYBSABKANIAIgBARIZCgxvbnVfaWZfaW5kZXgYBiABKAlIAYgBARIaChJhbHNvX29uX2lmX2luZGV4ZXMYByADKANCCQoHX29udV9uckIPCg1fb251X2lmX2luZGV4IjQKC0Rlc2NyaXB0aW9uEhAKCGlmX2luZGV4GAEgASgDEhMKC2Rlc2NyaXB0aW9uGAIgASgJIvMBCgZJZkluZm8SEAoIaWZfaW5kZXgYASABKAMSDAoEbmFtZRgCIAEoCRIZCgxzdGF0dXNfYWRtaW4YAyABKAhIAIgBARIYCgtzdGF0dXNfb3BlchgEIAEoCEgBiAEBEhEKBHR5cGUYBSABKAlIAogBARIcCg9wb3J0X3NwZWVkX21iaXQYBiABKANIA4gBARIQCghzb3J0X2tleRgHIAEoAxITCgtkZXNjcmlwdGlvbhgIIAEoCUIPCg1fc3RhdHVzX2FkbWluQg4KDF9zdGF0dXNfb3BlckIHCgVfdHlwZUISChBfcG9ydF9zcGVlZF9tYml0IkQKCUlmVHJhZmZpYxIQCghpZl9pbmRleBgBIAEoAxIRCglpbl9vY3RldHMYAiABKAMSEgoKb3V0X29jdGV0cxgDIAEoAyJqCghJZkVycm9ycxIQCghpZl9pbmRleBgBIAEoAxIWCglpbl9lcnJvcnMYAiABKANIAIgBARIXCgpvdXRfZXJyb3JzGAMgASgDSAGIAQFCDAoKX2luX2Vycm9yc0INCgtfb3V0X2Vycm9ycyJjChJJZkNoYW5nZVN0YXR1c0luZm8SEAoIaWZfaW5kZXgYASABKAMSKwoGYWN0aW9uGAIgASgOMhsud29ya2VybmV0LnBvbGxlcnMuSWZTdGF0dXMSDgoGc3RhdHVzGAMgASgIIjQKEElmQ2hhbmdlRGVzY0luZm8SEAoIaWZfaW5kZXgYASABKAMSDgoGc3RhdHVzGAIgASgIIlkKCUNhYmxlUGFpchIKCgJuchgBIAEoAxIMCgRuYW1lGAIgASgJEg4KBnN0YXR1cxgDIAEoCRIVCghkaXN0YW5jZRgEIAEoA0gAiAEBQgsKCV9kaXN0YW5jZSKgAQoMTWVhc3VyZWRQb3J0EhAKCGlmX2luZGV4GAEgASgDEhEKCWlzX2FjdGl2ZRgCIAEoCBITCgZzdGF0dXMYAyABKAlIAIgBARITCgZsZW5ndGgYBCABKANIAYgBARIrCgVwYWlycxgFIAMoCzIcLndvcmtlcm5ldC5wb2xsZXJzLkNhYmxlUGFpckIJCgdfc3RhdHVzQgkKB19sZW5ndGgiRAoOU25tcFJlYWRSZXN1bHQSEAoIdmFyX2JpbmQYASABKAkSEQoJc25tcF90eXBlGAIgASgJEg0KBXZhbHVlGAMgASgJIjcKB1BhY2tldHMSDAoEc2VudBgBIAEoAxIQCghyZWNlaXZlZBgCIAEoAxIMCgRsb3NzGAMgASgBIkkKA1RSUhILCgNtaW4YASABKAESCwoDbWF4GAIgASgBEgsKA2F2ZxgDIAEoARILCgNhbGwYBCADKAESDgoGaml0dGVyGAUgASgBInAKClBpbmdSZXN1bHQSEAoIaXNfYWxpdmUYASABKAgSKwoHcGFja2V0cxgCIAEoCzIaLndvcmtlcm5ldC5wb2xsZXJzLlBhY2tldHMSIwoDdHJyGAMgASgLMhYud29ya2VybmV0LnBvbGxlcnMuVFJSIkMKClZsYW5SZXN1bHQSCwoDdmlkGAEgASgDEgwKBG5hbWUYAiABKAkSCwoDdGFnGAMgAygDEg0KBXVudGFnGAQgAygDIiMKCEFycEVudHJ5EgoKAmlwGAEgASgJEgsKA21hYxgCIAEoCSpcChFTbm1wU2VjdXJpdHlMZXZlbBIWChJOT19BVVRIX09SX1BSSVZBQ1kQABIYChRBVVRIX1dJVEhPVVRfUFJJVkFDWRABEhUKEUFVVEhfV0lUSF9QUklWQUNZEAIqIAoMQXV0aFByb3RvY29sEgcKA01ENRAAEgcKA1NIQRABKiAKDFByaXZQcm90b2NvbBIHCgNERVMQABIHCgNBRVMQASojCg5SZXNwb25zZVN0YXR1cxIGCgJPSxAAEgkKBUVSUk9SEAEqJAoNU2VydmljZVN0YXR1cxIJCgVTVEFSVBAAEggKBFNUT1AQASoqCgdQb25UeXBlEggKBEVQT04QABIICgRHUE9OEAESCwoHVU5LTk9XThACKjkKD0RlcmVnUmVhc29uVHlwZRIHCgNMT1MQABIICgRMT1NJEAESCAoETE9GSRACEgkKBU9USEVSEAMqHAoISWZTdGF0dXMSBgoCVVAQABIICgRET1dOEAFCOlo4Z2l0aHViLmNvbS93b3JrZXJuZXQvYmFja2VuZC9wa2cvcGIvcG9sbGVycy92MTtwb2xsZXJzdjFiBnByb3RvMw", [file_google_protobuf_any, file_common_v1_common, file_common_v1_workers]);

/**
 * @generated from message workernet.pollers.EquipmentInfo
 */
export type EquipmentInfo = Message<"workernet.pollers.EquipmentInfo"> & {
  /**
   * @generated from field: string vendor = 1;
   */
  vendor: string;

  /**
   * @generated from field: string model = 2;
   */
  model: string;

  /**
   * @generated from field: string sw_ver = 3;
   */
  swVer: string;

  /**
   * @generated from field: string hw_ver = 4;
   */
  hwVer: string;
};

/**
 * Describes the message workernet.pollers.EquipmentInfo.
 * Use `create(EquipmentInfoSchema)` to create a new message.
 */
export const EquipmentInfoSchema: GenMessage<EquipmentInfo> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 0);

/**
 * @generated from message workernet.pollers.OnuId
 */
export type OnuId = Message<"workernet.pollers.OnuId"> & {
  /**
   * @generated from field: optional int64 olt_if_index = 1;
   */
  oltIfIndex?: bigint | undefined;

  /**
   * @generated from field: optional int64 nr = 2;
   */
  nr?: bigint | undefined;

  /**
   * @generated from field: optional string unique_id = 3;
   */
  uniqueId?: string | undefined;
};

/**
 * Describes the message workernet.pollers.OnuId.
 * Use `create(OnuIdSchema)` to create a new message.
 */
export const OnuIdSchema: GenMessage<OnuId> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 1);

/**
 * @generated from message workernet.pollers.Payload
 */
export type Payload = Message<"workernet.pollers.Payload"> & {
  /**
   * @generated from field: int64 count = 1;
   */
  count: bigint;

  /**
   * @generated from field: double interval = 2;
   */
  interval: number;

  /**
   * @generated from field: int64 size = 3;
   */
  size: bigint;

  /**
   * @generated from field: repeated string oids = 4;
   */
  oids: string[];

  /**
   * @generated from field: int64 timeout = 5;
   */
  timeout: bigint;

  /**
   * @generated from field: int64 retries = 6;
   */
  retries: bigint;

  /**
   * @generated from field: int64 max_repetitions = 7;
   */
  maxRepetitions: bigint;

  /**
   * @generated from field: string community_suffix = 8;
   */
  communitySuffix: string;

  /**
   * @generated from field: int64 chunk_size = 9;
   */
  chunkSize: bigint;

  /**
   * @generated from field: bool one_at_a_time = 10;
   */
  oneAtATime: boolean;
};

/**
 * Describes the message workernet.pollers.Payload.
 * Use `create(PayloadSchema)` to create a new message.
 */
export const PayloadSchema: GenMessage<Payload> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 2);

/**
 * @generated from message workernet.pollers.OnuDeregReason
 */
export type OnuDeregReason = Message<"workernet.pollers.OnuDeregReason"> & {
  /**
   * @generated from field: workernet.pollers.OnuId id = 1;
   */
  id?: OnuId | undefined;

  /**
   * @generated from field: google.protobuf.Any value = 2;
   */
  value?: Any | undefined;

  /**
   * @generated from field: workernet.pollers.DeregReasonType type = 3;
   */
  type: DeregReasonType;
};

/**
 * Describes the message workernet.pollers.OnuDeregReason.
 * Use `create(OnuDeregReasonSchema)` to create a new message.
 */
export const OnuDeregReasonSchema: GenMessage<OnuDeregReason> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 3);

/**
 * @generated from message workernet.pollers.OnuInfo
 */
export type OnuInfo = Message<"workernet.pollers.OnuInfo"> & {
  /**
   * @generated from field: workernet.pollers.OnuId id = 1;
   */
  id?: OnuId | undefined;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: workernet.pollers.PonType type = 3;
   */
  type: PonType;

  /**
   * @generated from field: optional workernet.workers.OnuSerial sn = 4;
   */
  sn?: OnuSerial | undefined;

  /**
   * @generated from field: string mac = 5;
   */
  mac: string;

  /**
   * @generated from field: workernet.pollers.EquipmentInfo equipment_info = 6;
   */
  equipmentInfo?: EquipmentInfo | undefined;

  /**
   * @generated from field: int64 sort_key = 7;
   */
  sortKey: bigint;

  /**
   * @generated from field: string desc = 8;
   */
  desc: string;
};

/**
 * Describes the message workernet.pollers.OnuInfo.
 * Use `create(OnuInfoSchema)` to create a new message.
 */
export const OnuInfoSchema: GenMessage<OnuInfo> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 4);

/**
 * @generated from message workernet.pollers.OnuMeasurement
 */
export type OnuMeasurement = Message<"workernet.pollers.OnuMeasurement"> & {
  /**
   * @generated from field: workernet.pollers.OnuId id = 1;
   */
  id?: OnuId | undefined;

  /**
   * @generated from field: google.protobuf.Any value = 2;
   */
  value?: Any | undefined;
};

/**
 * Describes the message workernet.pollers.OnuMeasurement.
 * Use `create(OnuMeasurementSchema)` to create a new message.
 */
export const OnuMeasurementSchema: GenMessage<OnuMeasurement> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 5);

/**
 * @generated from message workernet.pollers.OnuIfTraffic
 */
export type OnuIfTraffic = Message<"workernet.pollers.OnuIfTraffic"> & {
  /**
   * @generated from field: int64 in_octets = 1;
   */
  inOctets: bigint;

  /**
   * @generated from field: int64 out_octets = 2;
   */
  outOctets: bigint;
};

/**
 * Describes the message workernet.pollers.OnuIfTraffic.
 * Use `create(OnuIfTrafficSchema)` to create a new message.
 */
export const OnuIfTrafficSchema: GenMessage<OnuIfTraffic> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 6);

/**
 * @generated from message workernet.pollers.OnuIfErrors
 */
export type OnuIfErrors = Message<"workernet.pollers.OnuIfErrors"> & {
  /**
   * @generated from field: optional int64 in_errors = 1;
   */
  inErrors?: bigint | undefined;

  /**
   * @generated from field: optional int64 out_errors = 2;
   */
  outErrors?: bigint | undefined;
};

/**
 * Describes the message workernet.pollers.OnuIfErrors.
 * Use `create(OnuIfErrorsSchema)` to create a new message.
 */
export const OnuIfErrorsSchema: GenMessage<OnuIfErrors> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 7);

/**
 * @generated from message workernet.pollers.OnuInterface
 */
export type OnuInterface = Message<"workernet.pollers.OnuInterface"> & {
  /**
   * @generated from field: workernet.pollers.OnuId onu_id = 1;
   */
  onuId?: OnuId | undefined;

  /**
   * @generated from field: int64 number = 2;
   */
  number: bigint;

  /**
   * @generated from field: optional int64 if_index = 3;
   */
  ifIndex?: bigint | undefined;

  /**
   * @generated from field: optional bool status_admin = 4;
   */
  statusAdmin?: boolean | undefined;

  /**
   * @generated from field: optional bool status_oper = 5;
   */
  statusOper?: boolean | undefined;

  /**
   * @generated from field: optional int64 port_speed_mbit = 6;
   */
  portSpeedMbit?: bigint | undefined;

  /**
   * @generated from field: optional workernet.pollers.OnuIfTraffic traffic = 7;
   */
  traffic?: OnuIfTraffic | undefined;

  /**
   * @generated from field: optional workernet.pollers.OnuIfErrors errors = 8;
   */
  errors?: OnuIfErrors | undefined;
};

/**
 * Describes the message workernet.pollers.OnuInterface.
 * Use `create(OnuInterfaceSchema)` to create a new message.
 */
export const OnuInterfaceSchema: GenMessage<OnuInterface> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 8);

/**
 * @generated from message workernet.pollers.PonResult
 */
export type PonResult = Message<"workernet.pollers.PonResult"> & {
  /**
   * @generated from field: repeated workernet.pollers.OnuInfo onus = 1;
   */
  onus: OnuInfo[];

  /**
   * @generated from field: repeated workernet.pollers.OnuMeasurement onu_tx_power = 2;
   */
  onuTxPower: OnuMeasurement[];

  /**
   * @generated from field: repeated workernet.pollers.OnuMeasurement onu_rx_power = 3;
   */
  onuRxPower: OnuMeasurement[];

  /**
   * @generated from field: repeated workernet.pollers.OnuMeasurement olt_tx_power = 4;
   */
  oltTxPower: OnuMeasurement[];

  /**
   * @generated from field: repeated workernet.pollers.OnuMeasurement olt_rx_power = 5;
   */
  oltRxPower: OnuMeasurement[];

  /**
   * @generated from field: repeated workernet.pollers.OnuMeasurement distance = 6;
   */
  distance: OnuMeasurement[];

  /**
   * @generated from field: repeated workernet.pollers.OnuMeasurement temperature = 7;
   */
  temperature: OnuMeasurement[];

  /**
   * @generated from field: repeated workernet.pollers.OnuDeregReason dereg_reasons = 8;
   */
  deregReasons: OnuDeregReason[];

  /**
   * @generated from field: repeated workernet.pollers.OnuMeasurement state = 9;
   */
  state: OnuMeasurement[];

  /**
   * @generated from field: repeated workernet.pollers.OnuInterface interfaces = 10;
   */
  interfaces: OnuInterface[];
};

/**
 * Describes the message workernet.pollers.PonResult.
 * Use `create(PonResultSchema)` to create a new message.
 */
export const PonResultSchema: GenMessage<PonResult> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 9);

/**
 * @generated from message workernet.pollers.Signal
 */
export type Signal = Message<"workernet.pollers.Signal"> & {
  /**
   * @generated from field: optional int64 strength_rx = 1;
   */
  strengthRx?: bigint | undefined;

  /**
   * @generated from field: optional int64 snr_rx = 2;
   */
  snrRx?: bigint | undefined;

  /**
   * @generated from field: optional int64 ccq_tx = 3;
   */
  ccqTx?: bigint | undefined;
};

/**
 * Describes the message workernet.pollers.Signal.
 * Use `create(SignalSchema)` to create a new message.
 */
export const SignalSchema: GenMessage<Signal> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 10);

/**
 * @generated from message workernet.pollers.Traffic
 */
export type Traffic = Message<"workernet.pollers.Traffic"> & {
  /**
   * @generated from field: optional int64 tx = 1;
   */
  tx?: bigint | undefined;

  /**
   * @generated from field: optional int64 rx = 2;
   */
  rx?: bigint | undefined;
};

/**
 * Describes the message workernet.pollers.Traffic.
 * Use `create(TrafficSchema)` to create a new message.
 */
export const TrafficSchema: GenMessage<Traffic> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 11);

/**
 * @generated from message workernet.pollers.Rate
 */
export type Rate = Message<"workernet.pollers.Rate"> & {
  /**
   * @generated from field: optional double tx = 1;
   */
  tx?: number | undefined;

  /**
   * @generated from field: optional double rx = 2;
   */
  rx?: number | undefined;
};

/**
 * Describes the message workernet.pollers.Rate.
 * Use `create(RateSchema)` to create a new message.
 */
export const RateSchema: GenMessage<Rate> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 12);

/**
 * @generated from message workernet.pollers.Peer
 */
export type Peer = Message<"workernet.pollers.Peer"> & {
  /**
   * @generated from field: optional string mac = 1;
   */
  mac?: string | undefined;

  /**
   * @generated from field: optional string ip = 2;
   */
  ip?: string | undefined;

  /**
   * @generated from field: optional string name = 3;
   */
  name?: string | undefined;

  /**
   * @generated from field: optional string uptime_ticks = 4;
   */
  uptimeTicks?: string | undefined;

  /**
   * @generated from field: optional int64 uptime = 5;
   */
  uptime?: bigint | undefined;

  /**
   * @generated from field: optional workernet.pollers.Rate rate = 6;
   */
  rate?: Rate | undefined;

  /**
   * @generated from field: optional workernet.pollers.Signal signal = 7;
   */
  signal?: Signal | undefined;

  /**
   * @generated from field: optional workernet.pollers.Traffic traffic = 8;
   */
  traffic?: Traffic | undefined;
};

/**
 * Describes the message workernet.pollers.Peer.
 * Use `create(PeerSchema)` to create a new message.
 */
export const PeerSchema: GenMessage<Peer> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 13);

/**
 * @generated from message workernet.pollers.FdbItem
 */
export type FdbItem = Message<"workernet.pollers.FdbItem"> & {
  /**
   * @generated from field: string mac = 1;
   */
  mac: string;

  /**
   * @generated from field: int64 if_index = 2;
   */
  ifIndex: bigint;

  /**
   * @generated from field: repeated int64 vids = 3;
   */
  vids: bigint[];

  /**
   * @generated from field: string type = 4;
   */
  type: string;

  /**
   * @generated from field: optional int64 onu_nr = 5;
   */
  onuNr?: bigint | undefined;

  /**
   * @generated from field: optional string onu_if_index = 6;
   */
  onuIfIndex?: string | undefined;

  /**
   * @generated from field: repeated int64 also_on_if_indexes = 7;
   */
  alsoOnIfIndexes: bigint[];
};

/**
 * Describes the message workernet.pollers.FdbItem.
 * Use `create(FdbItemSchema)` to create a new message.
 */
export const FdbItemSchema: GenMessage<FdbItem> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 14);

/**
 * @generated from message workernet.pollers.Description
 */
export type Description = Message<"workernet.pollers.Description"> & {
  /**
   * @generated from field: int64 if_index = 1;
   */
  ifIndex: bigint;

  /**
   * @generated from field: string description = 2;
   */
  description: string;
};

/**
 * Describes the message workernet.pollers.Description.
 * Use `create(DescriptionSchema)` to create a new message.
 */
export const DescriptionSchema: GenMessage<Description> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 15);

/**
 * @generated from message workernet.pollers.IfInfo
 */
export type IfInfo = Message<"workernet.pollers.IfInfo"> & {
  /**
   * @generated from field: int64 if_index = 1;
   */
  ifIndex: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional bool status_admin = 3;
   */
  statusAdmin?: boolean | undefined;

  /**
   * @generated from field: optional bool status_oper = 4;
   */
  statusOper?: boolean | undefined;

  /**
   * @generated from field: optional string type = 5;
   */
  type?: string | undefined;

  /**
   * @generated from field: optional int64 port_speed_mbit = 6;
   */
  portSpeedMbit?: bigint | undefined;

  /**
   * @generated from field: int64 sort_key = 7;
   */
  sortKey: bigint;

  /**
   * @generated from field: string description = 8;
   */
  description: string;
};

/**
 * Describes the message workernet.pollers.IfInfo.
 * Use `create(IfInfoSchema)` to create a new message.
 */
export const IfInfoSchema: GenMessage<IfInfo> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 16);

/**
 * @generated from message workernet.pollers.IfTraffic
 */
export type IfTraffic = Message<"workernet.pollers.IfTraffic"> & {
  /**
   * @generated from field: int64 if_index = 1;
   */
  ifIndex: bigint;

  /**
   * @generated from field: int64 in_octets = 2;
   */
  inOctets: bigint;

  /**
   * @generated from field: int64 out_octets = 3;
   */
  outOctets: bigint;
};

/**
 * Describes the message workernet.pollers.IfTraffic.
 * Use `create(IfTrafficSchema)` to create a new message.
 */
export const IfTrafficSchema: GenMessage<IfTraffic> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 17);

/**
 * @generated from message workernet.pollers.IfErrors
 */
export type IfErrors = Message<"workernet.pollers.IfErrors"> & {
  /**
   * @generated from field: int64 if_index = 1;
   */
  ifIndex: bigint;

  /**
   * @generated from field: optional int64 in_errors = 2;
   */
  inErrors?: bigint | undefined;

  /**
   * @generated from field: optional int64 out_errors = 3;
   */
  outErrors?: bigint | undefined;
};

/**
 * Describes the message workernet.pollers.IfErrors.
 * Use `create(IfErrorsSchema)` to create a new message.
 */
export const IfErrorsSchema: GenMessage<IfErrors> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 18);

/**
 * @generated from message workernet.pollers.IfChangeStatusInfo
 */
export type IfChangeStatusInfo = Message<"workernet.pollers.IfChangeStatusInfo"> & {
  /**
   * @generated from field: int64 if_index = 1;
   */
  ifIndex: bigint;

  /**
   * @generated from field: workernet.pollers.IfStatus action = 2;
   */
  action: IfStatus;

  /**
   * @generated from field: bool status = 3;
   */
  status: boolean;
};

/**
 * Describes the message workernet.pollers.IfChangeStatusInfo.
 * Use `create(IfChangeStatusInfoSchema)` to create a new message.
 */
export const IfChangeStatusInfoSchema: GenMessage<IfChangeStatusInfo> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 19);

/**
 * @generated from message workernet.pollers.IfChangeDescInfo
 */
export type IfChangeDescInfo = Message<"workernet.pollers.IfChangeDescInfo"> & {
  /**
   * @generated from field: int64 if_index = 1;
   */
  ifIndex: bigint;

  /**
   * @generated from field: bool status = 2;
   */
  status: boolean;
};

/**
 * Describes the message workernet.pollers.IfChangeDescInfo.
 * Use `create(IfChangeDescInfoSchema)` to create a new message.
 */
export const IfChangeDescInfoSchema: GenMessage<IfChangeDescInfo> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 20);

/**
 * @generated from message workernet.pollers.CablePair
 */
export type CablePair = Message<"workernet.pollers.CablePair"> & {
  /**
   * @generated from field: int64 nr = 1;
   */
  nr: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * @generated from field: optional int64 distance = 4;
   */
  distance?: bigint | undefined;
};

/**
 * Describes the message workernet.pollers.CablePair.
 * Use `create(CablePairSchema)` to create a new message.
 */
export const CablePairSchema: GenMessage<CablePair> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 21);

/**
 * @generated from message workernet.pollers.MeasuredPort
 */
export type MeasuredPort = Message<"workernet.pollers.MeasuredPort"> & {
  /**
   * @generated from field: int64 if_index = 1;
   */
  ifIndex: bigint;

  /**
   * @generated from field: bool is_active = 2;
   */
  isActive: boolean;

  /**
   * @generated from field: optional string status = 3;
   */
  status?: string | undefined;

  /**
   * @generated from field: optional int64 length = 4;
   */
  length?: bigint | undefined;

  /**
   * @generated from field: repeated workernet.pollers.CablePair pairs = 5;
   */
  pairs: CablePair[];
};

/**
 * Describes the message workernet.pollers.MeasuredPort.
 * Use `create(MeasuredPortSchema)` to create a new message.
 */
export const MeasuredPortSchema: GenMessage<MeasuredPort> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 22);

/**
 * @generated from message workernet.pollers.SnmpReadResult
 */
export type SnmpReadResult = Message<"workernet.pollers.SnmpReadResult"> & {
  /**
   * @generated from field: string var_bind = 1;
   */
  varBind: string;

  /**
   * @generated from field: string snmp_type = 2;
   */
  snmpType: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;
};

/**
 * Describes the message workernet.pollers.SnmpReadResult.
 * Use `create(SnmpReadResultSchema)` to create a new message.
 */
export const SnmpReadResultSchema: GenMessage<SnmpReadResult> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 23);

/**
 * @generated from message workernet.pollers.Packets
 */
export type Packets = Message<"workernet.pollers.Packets"> & {
  /**
   * @generated from field: int64 sent = 1;
   */
  sent: bigint;

  /**
   * @generated from field: int64 received = 2;
   */
  received: bigint;

  /**
   * @generated from field: double loss = 3;
   */
  loss: number;
};

/**
 * Describes the message workernet.pollers.Packets.
 * Use `create(PacketsSchema)` to create a new message.
 */
export const PacketsSchema: GenMessage<Packets> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 24);

/**
 * @generated from message workernet.pollers.TRR
 */
export type TRR = Message<"workernet.pollers.TRR"> & {
  /**
   * @generated from field: double min = 1;
   */
  min: number;

  /**
   * @generated from field: double max = 2;
   */
  max: number;

  /**
   * @generated from field: double avg = 3;
   */
  avg: number;

  /**
   * @generated from field: repeated double all = 4;
   */
  all: number[];

  /**
   * @generated from field: double jitter = 5;
   */
  jitter: number;
};

/**
 * Describes the message workernet.pollers.TRR.
 * Use `create(TRRSchema)` to create a new message.
 */
export const TRRSchema: GenMessage<TRR> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 25);

/**
 * @generated from message workernet.pollers.PingResult
 */
export type PingResult = Message<"workernet.pollers.PingResult"> & {
  /**
   * @generated from field: bool is_alive = 1;
   */
  isAlive: boolean;

  /**
   * @generated from field: workernet.pollers.Packets packets = 2;
   */
  packets?: Packets | undefined;

  /**
   * @generated from field: workernet.pollers.TRR trr = 3;
   */
  trr?: TRR | undefined;
};

/**
 * Describes the message workernet.pollers.PingResult.
 * Use `create(PingResultSchema)` to create a new message.
 */
export const PingResultSchema: GenMessage<PingResult> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 26);

/**
 * @generated from message workernet.pollers.VlanResult
 */
export type VlanResult = Message<"workernet.pollers.VlanResult"> & {
  /**
   * @generated from field: int64 vid = 1;
   */
  vid: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: repeated int64 tag = 3;
   */
  tag: bigint[];

  /**
   * @generated from field: repeated int64 untag = 4;
   */
  untag: bigint[];
};

/**
 * Describes the message workernet.pollers.VlanResult.
 * Use `create(VlanResultSchema)` to create a new message.
 */
export const VlanResultSchema: GenMessage<VlanResult> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 27);

/**
 * @generated from message workernet.pollers.ArpEntry
 */
export type ArpEntry = Message<"workernet.pollers.ArpEntry"> & {
  /**
   * @generated from field: string ip = 1;
   */
  ip: string;

  /**
   * @generated from field: string mac = 2;
   */
  mac: string;
};

/**
 * Describes the message workernet.pollers.ArpEntry.
 * Use `create(ArpEntrySchema)` to create a new message.
 */
export const ArpEntrySchema: GenMessage<ArpEntry> = /*@__PURE__*/
  messageDesc(file_poller_v1_pollers, 28);

/**
 * @generated from enum workernet.pollers.SnmpSecurityLevel
 */
export enum SnmpSecurityLevel {
  /**
   * @generated from enum value: NO_AUTH_OR_PRIVACY = 0;
   */
  NO_AUTH_OR_PRIVACY = 0,

  /**
   * @generated from enum value: AUTH_WITHOUT_PRIVACY = 1;
   */
  AUTH_WITHOUT_PRIVACY = 1,

  /**
   * @generated from enum value: AUTH_WITH_PRIVACY = 2;
   */
  AUTH_WITH_PRIVACY = 2,
}

/**
 * Describes the enum workernet.pollers.SnmpSecurityLevel.
 */
export const SnmpSecurityLevelSchema: GenEnum<SnmpSecurityLevel> = /*@__PURE__*/
  enumDesc(file_poller_v1_pollers, 0);

/**
 * @generated from enum workernet.pollers.AuthProtocol
 */
export enum AuthProtocol {
  /**
   * @generated from enum value: MD5 = 0;
   */
  MD5 = 0,

  /**
   * @generated from enum value: SHA = 1;
   */
  SHA = 1,
}

/**
 * Describes the enum workernet.pollers.AuthProtocol.
 */
export const AuthProtocolSchema: GenEnum<AuthProtocol> = /*@__PURE__*/
  enumDesc(file_poller_v1_pollers, 1);

/**
 * @generated from enum workernet.pollers.PrivProtocol
 */
export enum PrivProtocol {
  /**
   * @generated from enum value: DES = 0;
   */
  DES = 0,

  /**
   * @generated from enum value: AES = 1;
   */
  AES = 1,
}

/**
 * Describes the enum workernet.pollers.PrivProtocol.
 */
export const PrivProtocolSchema: GenEnum<PrivProtocol> = /*@__PURE__*/
  enumDesc(file_poller_v1_pollers, 2);

/**
 * @generated from enum workernet.pollers.ResponseStatus
 */
export enum ResponseStatus {
  /**
   * @generated from enum value: OK = 0;
   */
  OK = 0,

  /**
   * @generated from enum value: ERROR = 1;
   */
  ERROR = 1,
}

/**
 * Describes the enum workernet.pollers.ResponseStatus.
 */
export const ResponseStatusSchema: GenEnum<ResponseStatus> = /*@__PURE__*/
  enumDesc(file_poller_v1_pollers, 3);

/**
 * @generated from enum workernet.pollers.ServiceStatus
 */
export enum ServiceStatus {
  /**
   * @generated from enum value: START = 0;
   */
  START = 0,

  /**
   * @generated from enum value: STOP = 1;
   */
  STOP = 1,
}

/**
 * Describes the enum workernet.pollers.ServiceStatus.
 */
export const ServiceStatusSchema: GenEnum<ServiceStatus> = /*@__PURE__*/
  enumDesc(file_poller_v1_pollers, 4);

/**
 * @generated from enum workernet.pollers.PonType
 */
export enum PonType {
  /**
   * @generated from enum value: EPON = 0;
   */
  EPON = 0,

  /**
   * @generated from enum value: GPON = 1;
   */
  GPON = 1,

  /**
   * @generated from enum value: UNKNOWN = 2;
   */
  UNKNOWN = 2,
}

/**
 * Describes the enum workernet.pollers.PonType.
 */
export const PonTypeSchema: GenEnum<PonType> = /*@__PURE__*/
  enumDesc(file_poller_v1_pollers, 5);

/**
 * @generated from enum workernet.pollers.DeregReasonType
 */
export enum DeregReasonType {
  /**
   * @generated from enum value: LOS = 0;
   */
  LOS = 0,

  /**
   * @generated from enum value: LOSI = 1;
   */
  LOSI = 1,

  /**
   * @generated from enum value: LOFI = 2;
   */
  LOFI = 2,

  /**
   * @generated from enum value: OTHER = 3;
   */
  OTHER = 3,
}

/**
 * Describes the enum workernet.pollers.DeregReasonType.
 */
export const DeregReasonTypeSchema: GenEnum<DeregReasonType> = /*@__PURE__*/
  enumDesc(file_poller_v1_pollers, 6);

/**
 * @generated from enum workernet.pollers.IfStatus
 */
export enum IfStatus {
  /**
   * @generated from enum value: UP = 0;
   */
  UP = 0,

  /**
   * @generated from enum value: DOWN = 1;
   */
  DOWN = 1,
}

/**
 * Describes the enum workernet.pollers.IfStatus.
 */
export const IfStatusSchema: GenEnum<IfStatus> = /*@__PURE__*/
  enumDesc(file_poller_v1_pollers, 7);

